// extracted by mini-css-extract-plugin
module.exports = {"appBar":"AppBarTheme__appBar--2qbEV","title":"AppBarTheme__title--2z4tm"};